const PHOTO_PRIVACY_KEY = "photo_privacy_accepted";

export const hasAcceptedPhotoPrivacy = (isSDK: boolean = false, isGuest: boolean = false): boolean => {
  if (isSDK || isGuest) {
    return false;
  }

  const token = localStorage.getItem("token");
  if (token) {
    return localStorage.getItem(PHOTO_PRIVACY_KEY) === "true";
  }

  return false;
};

export const acceptPhotoPrivacy = (isSDK: boolean = false, isGuest: boolean = false): void => {
  if (isSDK || isGuest) {
    return;
  }

  const token = localStorage.getItem("token");
  if (token) {
    localStorage.setItem(PHOTO_PRIVACY_KEY, "true");
  }
};

export const clearPhotoPrivacy = (): void => {
  localStorage.removeItem(PHOTO_PRIVACY_KEY);
};
